import React from 'react';
import PropTypes from 'prop-types';
import styles from './buttons.scss';

import sessionReader from '../../store/readHelpers/SessionReader';
import { t } from '../../services/i18nService';
import presignUrlService from '../../services/PresignUrlService';

const DownloadButton = ({ fileDownloadUrl, fileDownloadName, downloadCaption, usePresignUrl = false }) => {
    const downloadCaptionText = downloadCaption || t('general.download');

    const getPresignDownloadButton = () => (
        <button
            className={styles.button}
            rel="noreferrer noopener"
            onClick={downloadFile}
        >
            <i className="fa fa-download" aria-hidden="true" />{downloadCaptionText}
        </button>
    );

    const getDisabledDownloadButton = () => (
        <button
            disabled
            className={styles.button}
            rel="noreferrer noopener"
        >
            <i className="fa fa-download" aria-hidden="true" />{downloadCaptionText}
        </button>
    );

    const downloadFile = () => {
        // fileDownloadUrl is also used as identifier because it's unique
        presignUrlService.loadPresignedUrl(fileDownloadUrl, fileDownloadUrl)
            .then((presignedUrl) => {
                window.open(presignedUrl, '_blank');
            });
    };

    if (!sessionReader.isViewMediaScreen()) {
        return getDisabledDownloadButton();
    }

    if (usePresignUrl) {
        return getPresignDownloadButton();
    }

    return (
        <a
            className={styles.button}
            href={fileDownloadUrl}
            rel="noreferrer noopener"
            target="_blank"
            download={fileDownloadName || ''}
        >
            <i className="fa fa-download" aria-hidden="true" />{downloadCaptionText}
        </a>

    );
};

DownloadButton.propTypes = {
    fileDownloadUrl: PropTypes.string.isRequired,
    fileDownloadName: PropTypes.string,
    usePresignUrl: PropTypes.bool,
    downloadCaption: PropTypes.string,
};

export default DownloadButton;
